import $ from "jquery";
export function rotateGraphs() {
	$('#areaGraph > .graph').css('transform', 'rotate(0deg)');
	$('#responsibilityGraph > .graph').css('transform', 'rotate(0deg)');
}